import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import styles from './Pagination.module.css'
import cn from 'classnames';

const PaginationComponent = ({ paginator, selectPage, size }) => {

const { offset, limit, itemsCount } = paginator;
const canPreviousPage = offset > 0;
const pagesCount = itemsCount ? Math.ceil(itemsCount / limit) : 0;
const canNextPage = offset < itemsCount - limit;
const page = Math.floor(offset / limit);
const pagesLinks = () => {
    let result = [];

    
    if (pagesCount <= 7) {
      for (let i = 1; i <= pagesCount; i++) {
        result.push(i);
      }
    } else {
      if (page < 5) {
        result.push(1, 2, 3, 4, 5, <p>...</p>, pagesCount);
      } else if (page > pagesCount - 5) {
        result.push(1, <p>...</p>);
        for (let i = pagesCount - 4; i <= pagesCount; i++) result.push(i);
      } else {
        result.push(1, <p>...</p>);
        for (let i = page; i <= page + 2; i++) {
          result.push(i);
        }
        result.push(<p>...</p>, pagesCount);
      }
    }
    return result;
  };

  return (
    <Pagination className={cn({'pagination-sm': window.innerWidth < 425, 'pagination-lg': window.innerWidth > 1440 }, styles.pagination, size)}>
      <Pagination.Prev className={styles.paginationLink}
        onClick={() => selectPage(page - 1)}
        disabled={!canPreviousPage}
      />

{itemsCount &&
          pagesLinks()?.map(item =>
            item ===  <p>...</p> ? (
                <p>...</p>
            ) : (
              <Pagination.Item className={styles.paginationItem}
                key={`page${item}`}
                onClick={() => selectPage(item - 1)}
                active={item === page+1}
              >
                {item}
              </Pagination.Item>
            ),
          )}

      <Pagination.Next className={styles.paginationLink}
        onClick={() => selectPage(page + 1)}
        disabled={!canNextPage}
      />
    </Pagination>
  );
};

export default PaginationComponent;